<div class="container">
    <!-- Title -->
    <div class="text-center">
        <strong class="mainHeading">City Configuration</strong>
    </div>

    <div class="d-flex justify-content-between mt-2">
        <div class="d-flex gap-3">
            <!-- Buttons Group -->
            <button class="btn btn-success" (click)="openModal(createModal)" *ngIf="loginData.userType == 6">
                <i class="bi bi-file-earmark-plus me-1 mt-1"></i> New
            </button>
            <button class="btn btn-outline-primary me-1" ngbTooltip="Export" (click)="exportToExcel()">
                <i class="bi bi-box-arrow-right me-2"></i> Export
            </button>
            <button class="btn btn-outline-danger" ngbTooltip="Clear Filter" (click)="clearFilter()">
                <i class="bi bi-x-circle me-2"></i> Clear Filter
            </button>
        </div>

        <!-- City Select & Search Field -->
        <div class="d-flex align-items-center gap-2">
            <label for="typeOfUser" class="mb-0 w-50">Select City</label>
            <select (change)="onFilterCityChange($event)" class="form-select">
                <option value="">All</option>
                <option *ngFor="let city of cityList" [value]="city.id">{{ city.cityName }}</option>
            </select>

            <!-- Search Input -->
            <input type="text" class="form-control w-100" placeholder="Search..." [(ngModel)]="searchKey" (input)="filterCities()" />
        </div>
    </div>



    <div class="card shadow-lg p-4 mt-3">
        <div class="table-responsive">
            <table class="table table-bordered table-striped">
                <thead class="table-warning text-center">
                    <tr>
                        <!-- <th>Container ID</th> -->
                        <th>City Name</th>
                        <th>City URL</th>
                        <th>Credentials</th>
                        <th>Web Status</th>
                        <th *ngIf="loginData.userType == 6">Action</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let citylist of cityConfigList">
                        <td class="text-center">{{ citylist.cityName }}</td>
                        <td class="text-center">{{ citylist.cityUrl }}</td>
                        <td class="text-center hyperLink" (click)="viewCredential(citylist, detailModal)">View Details</td>
                        <td class="text-center">{{ citylist.webStatus ? 'Active' : 'InActive' }}</td>
                        <td class="text-center" *ngIf="loginData.userType == 6">
                            <i class="bi bi-pencil text-danger" (click)="editItem(citylist, createModal)"
                                style="cursor: pointer"></i>
                        </td>
                    </tr>
                    <tr *ngIf="cityConfigList?.length === 0">
                        <td colspan="10" class="text-center">No Data Found</td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>

    <ng-template #createModal let-modal>
        <div class="modal-header custom-modal-header">
            <h2 class="modal-title mt-3">{{isEditMode ? 'Edit Configuration' : 'New Configuration'}}
            </h2>
            <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss()"></button>
        </div>

        <form [formGroup]="configForm">
            <div class="modal-body">
                <!-- Select City -->
                <div class="mb-3">
                    <label class="form-label">Select City</label>
                    <select (change)="onCityChange($event)" formControlName="cityId" class="form-select" [ngClass]="{
                        'invalid-field':
                        configForm.controls['cityId'].invalid &&
                        configForm.controls['cityId'].touched
                      }">
                        <option *ngFor="let city of cityList" [value]="city.id">{{ city.cityName }}</option>
                    </select>
                </div>

                <!-- Enter Username -->
                <div class="mb-3">
                    <label class="form-label">Enter Username</label>
                    <input type="text" class="form-control" formControlName="username" [ngClass]="{
                        'invalid-field':
                        configForm.controls['username'].invalid &&
                        configForm.controls['username'].touched
                      }" />
                </div>

                <!-- Enter Password -->
                <div class="mb-3">
                    <label class="form-label">Enter Password</label>
                    <input type="password" class="form-control" formControlName="password" [ngClass]="{
                        'invalid-field':
                        configForm.controls['password'].invalid &&
                        configForm.controls['password'].touched
                      }" />
                </div>

                <!-- Enter City URL -->
                <div class="mb-3">
                    <label class="form-label">Enter City URL</label>
                    <input type="text" class="form-control" formControlName="cityUrl" [ngClass]="{
                        'invalid-field':
                        configForm.controls['cityUrl'].invalid &&
                        configForm.controls['cityUrl'].touched
                      }" />
                </div>
            </div>

            <div class="modal-footer d-flex justify-content-end">
                <button type="button" class="btn btn-success" (click)="saveConfig(isEditMode ? 'edit' : 'new')">{{isEditMode ? 'Update' :
                    'Submit'}}</button>
                <button type="button" class="btn btn-secondary" (click)="modal.dismiss()">Cancel</button>
            </div>
        </form>
    </ng-template>

    <ng-template #detailModal let-modal>
        <div class="modal-header custom-modal-header">
            <h2 class="modal-title mt-3">Credentials for Chennai</h2>
            <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss()"></button>
        </div>

        <form [formGroup]="credentialForm" autocomplete="off">
            <div class="modal-body">
                <!-- User Name -->
                <div class="mb-3">
                    <label class="form-label fw-bold">User Name</label>
                    <div class="border p-2 rounded bg-light">{{ credentialForm.get('userName')?.value }}</div>
                  </div>
                  
                  <!-- Password -->
                  <div class="mb-3">
                    <label class="form-label fw-bold">Password</label>
                    <div class="border p-2 rounded bg-light">{{ credentialForm.get('password')?.value }}</div>
                  </div>
            </div>
        </form>
    </ng-template>

</div>